// extracted by mini-css-extract-plugin
module.exports = {"_label":"Label__label__2q3Dm","_label--error":"Label__label--error__1cAZ8","_label--no-wrap":"Label__label--no-wrap__21lrA"};